export default {
    'newsletter.title': 'Budite prvi koji će saznati',
    'newsletter.btn': 'Pretplatite se',
    'newsletter.placeholder': 'Vaš e-mail',
    'newsletter.subtitle': 'Ostanite informirani i budite prvi koji će saznati novosti!',
    'instagram.title': 'Pratite nas',
    'contact.title': 'Trebate pomoć?',
    'contact.hours': 'Pon - Pet: 9:00 - 19:00',
    'login.title': 'Prijava na račun',
    'cart.orderRecap': 'Pregled narudžbi',
    "cart.empty": "Vaša košarica je prazna",
    "cart.back": "Natrag u trgovinu",
    "prefix": "Slanjem poruke pristajete na ",
    "privacy": "pravila o zaštiti privatnosti"
}